module.exports = __webpack_public_path__ + "img/web_home.f5bdf892.png";